// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as MailOutlineComponent} from './MailOutline.svg';

import Icon, { TIconProps } from '../Icon';

export const IconMailOutline = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <MailOutlineComponent/>
  </Icon>
));
